import BarChart from "./BarChart"
import DonutChart from "./DonutChart"
import TransactionLedger from "./TransactionLedger"

const components = { BarChart, DonutChart, TransactionLedger }

export default components
